// D.1: THE ASSESSMENT SITE'S WEB ADDRESSES, in one place (PRD D.1).
//
// Each is read from a REACT_APP_* env variable and falls back to today's
// staging value, so nothing has to be set for staging to behave exactly as it
// does. D.2 (the portal's custom domain, Dan's DNS step) changes the portal's
// value here. `config.test.js` fails if a staging hosting address appears
// anywhere else in this app's source (src); the Firebase initialisation is
// exempt by name, because the project's auth domain belongs there.

/** The client portal (APC-Intake-Builder's default site). */
export const PORTAL_BASE = process.env.REACT_APP_PORTAL_BASE || 'https://apc-intake-staging.web.app';

/** Where a client goes when there is no launch to return them from (S5b.2): the portal's home. */
export const PORTAL_HOME = `${PORTAL_BASE}/`;
